import { Fragment } from 'react'
import ListadoArticulos from './ListadoArticulos'

const ArticulosRelacionados = props => {
  return (
    <Fragment>
      <ListadoArticulos
        origen='relacionados'
        mostrar={'lista'}
        id_articulo={props.id_articulo}
        set_hay_relacionados={props.existen_relacionados}
      />
    </Fragment>
  )
}

export default ArticulosRelacionados
